import { render, staticRenderFns } from "./content-button.vue?vue&type=template&id=4be76af6&scoped=true&"
import script from "./content-button.vue?vue&type=script&lang=js&"
export * from "./content-button.vue?vue&type=script&lang=js&"
import style0 from "./content-button.vue?vue&type=style&index=0&id=4be76af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be76af6",
  null
  
)

export default component.exports